/**
 * feat-235 — a Track's visual identity when it has no art yet.
 *
 * THERE IS NO MASCOT PICKER FOR TRACKS, by design (mockup §9, spec "Frontend
 * slice"). `UNIT_MASCOT_CATALOG` is ten frozen Ladle & Leaf *lesson* themes
 * (`perfect_pairing`, `handling_no_thanks`, `portion_control`, …) — a menu with
 * no right answer for Greeter / Busser / Expo / Runner — and extending it is a
 * cross-app contract change that lands with Flutter art, not a frontend edit.
 * `mascot_key` / `completed_mascot_key` still ship in migration 114 per D10; this
 * is a decision about a CONTROL, not a column.
 *
 * What the picker would have solved is real: art arrives late, and in the gap
 * every art-less track is the same grey square. A DERIVED MONOGRAM fills it —
 * zero author decisions, never wrong, updates on rename, and it disappears the
 * moment real art is uploaded.
 */

/**
 * Two-character monogram derived from a Track title. TWO characters, not one:
 * "Busser" and "Barista" would otherwise be the same square.
 *
 * Splits by CODE POINT (`Array.from`), not by UTF-16 unit — slicing a title that
 * starts with an emoji or an astral character two units in produces half a
 * surrogate pair, which renders as a replacement glyph.
 */
export function trackMonogram(title: string): string {
  const chars = Array.from((title ?? '').trim()).filter((c) => !/\s/.test(c));
  if (chars.length === 0) return '?';
  return chars.slice(0, 2).join('').toUpperCase();
}
